export enum StorageKeys {
  UserLocale = 'WestminsterUserLocale',
  SWRCache = 'WestminsterSWRCache_20250427',
  MapConsent = 'WestminsterMapConsent',
}
